const ALLOWED = ['normal', 'new_license', 'license_renewal'];

/** Align with backend helpers. */
export function normalizeWorkflowLicenseMode(storedMode, licenseRenewal) {
  if (ALLOWED.includes(storedMode)) {
    return storedMode;
  }
  return licenseRenewal === true ||
    licenseRenewal === 1 ||
    licenseRenewal === '1'
    ? 'license_renewal'
    : 'new_license';
}

/**
 * Vertical "License Information" tab: hidden for normal workflows, or when no submission form enables HCP — unless row already exists from a prior submission.
 */
export function computeEffectiveHasHcpLicensesTab({
  workflowLicenseMode,
  licenseRenewalFallback,
  anySubmissionFormHasHcpLicenses,
  entryFormHasHcpFlag,
  hcpListRowPresent,
}) {
  const mode = normalizeWorkflowLicenseMode(
    workflowLicenseMode,
    licenseRenewalFallback
  );
  if (mode === 'normal') {
    return false;
  }
  return (
    anySubmissionFormHasHcpLicenses === true ||
    entryFormHasHcpFlag === true ||
    hcpListRowPresent === true
  );
}

/**
 * Merge workflow license fields from `workflowSubmissionLicenseMeta`, nested
 * `WorkflowVersion` / `wf_version`, or top-level request fields (same priority
 * as {@link MultiFormContext} send-back init).
 */
export function resolveWorkflowLicenseFieldsFromRequestDetails(
  requestDetails = {}
) {
  const meta = requestDetails.workflowSubmissionLicenseMeta || {};
  const wf = requestDetails.WorkflowVersion || requestDetails.wf_version || {};
  return {
    workflowLicenseMode:
      meta.workflow_license_mode ??
      wf.workflow_license_mode ??
      requestDetails.workflow_license_mode,
    licenseRenewalFallback:
      meta.license_renewal ??
      wf.license_renewal ??
      requestDetails.license_renewal,
    anySubmissionFormHasHcpLicenses:
      meta.anySubmissionFormHasHcpLicenses === true,
  };
}
